export default __webpack_public_path__ + "static/media/addadminclose.abb77bf5.svg";